import axios from "axios";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ThemeMaker from "../../components/thememaker";
import { config } from "../../utils/config";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";

const ApprovedenumList = () => {
    const history = useHistory();
    const apiUrl = config.baseNodeapiUrl;

    const [providerList, setProviderList] = useState([]);
    const [loading, setLoading] = useState(false);

    const getAllList = async () => {
        setLoading(true);

        try {
            const response = await axios({
                url: `${apiUrl}/admin/api/social-sector-providers`,
                method: "GET",
            });

            setProviderList(response?.data?.data || []);
        } catch (error) {
            console.log("Error ------>", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAllList();
    }, []);

    const handleEdit = (id) => {
        history.push(`/approved-enums/${id}`)
    };

    const handleDelete = async (id) => {
        const confirmDelete = window.confirm(
            "Are you sure you want to delete this credential?"
        );

        if (!confirmDelete) return;

        try {
            await axios({
                url: `${apiUrl}/admin/api/social-sector-providers/${id}`,
                method: "DELETE",
            });
            getAllList();
            alert("Deleted successfully.");
        } catch (error) {
            console.log("Delete Error ----->", error);
            alert("Failed to delete.");
        }
    };

    return (
        <ThemeMaker>
            <div className="container-fluid mt-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3>Credentials List</h3>

                    <button
                        className="btn btn-success"
                        onClick={() => history.push("/approved-enums")}
                    >
                        + Add Credential
                    </button>
                </div>

                <div className="table-responsive">
                    <table className="table table-bordered table-hover align-middle">
                        <thead className="table-dark">
                            <tr>
                                <th>#</th>
                                <th>Logo</th>
                                <th>Credential ID</th>
                                <th>Descriptor Code</th>
                                <th>Short Description</th>
                                <th>Name</th>
                                <th>Valid From</th>
                                <th>Valid To</th>
                                <th>Status</th>
                                <th width="170">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="10" className="text-center py-4">
                                        Loading...
                                    </td>
                                </tr>
                            ) : providerList.length > 0 ? (
                                providerList.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>

                                        <td>
                                            <img
                                                src={item.url}
                                                alt={item.descriptor_name}
                                                width={55}
                                                height={55}
                                                style={{
                                                    objectFit: "contain",
                                                    borderRadius: "6px",
                                                    border: "1px solid #ddd",
                                                    padding: "3px",
                                                }}
                                            />
                                        </td>

                                        <td>{item.credential_id}</td>
                                        <td>{item.descriptor_code}</td>
                                        <td>{item.descriptor_short_desc}</td>
                                        <td>{item.descriptor_name}</td>
                                        <td>{item.valid_from}</td>
                                        <td>{item.valid_to}</td>

                                        <td>
                                            <span
                                                className={`badge text-white ${item.is_active ? "bg-success" : "bg-danger"
                                                    }`}
                                            >
                                                {item.is_active ? "Active" : "Inactive"}
                                            </span>
                                        </td>

                                        <td>
                                            <div className="d-flex justify-content-center" style={{gap: "10px"}}>
                                                <span style={{cursor: "pointer"}}
                                                    className="text-success"
                                                    onClick={() => handleEdit(item?.id)}>
                                                    <FaRegEdit />
                                                </span>

                                                <span style={{ cursor: "pointer" }} className="text-danger"
                                                    onClick={() => handleDelete(item.id)}>
                                                    <RiDeleteBin6Line />
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" className="text-center py-4">
                                        No Data Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </ThemeMaker>
    );
};

export default ApprovedenumList;